import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <Section background="light" className="overflow-hidden" data-id="element-115">
      <div className="text-center mb-10" data-id="element-116">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0f1923] mb-4" data-id="element-117">
          Presentando el Triángulo Anti-Pantalla
        </h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-118">
          Este plan funciona porque no depende de motivación. Depende de un
          mecanismo simple.
        </p>
      </div>

      <div className="relative max-w-4xl mx-auto py-6" data-id="element-119">
        {/* Triangle Visualization */}
        <div className="relative flex flex-col items-center justify-center min-h-[400px]" data-id="element-120">
          {/* Central Triangle Graphic (CSS/SVG) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8,
          rotate: -10
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 1
        }} className="absolute inset-0 flex items-center justify-center z-0 opacity-10 md:opacity-100" data-id="element-121">
            <svg width="300" height="300" viewBox="0 0 100 100" className="drop-shadow-2xl" data-id="element-122">
              <path d="M50 15 L90 85 L10 85 Z" fill="none" stroke="#c9a84c" strokeWidth="2" data-id="element-123" />
              <path d="M50 25 L80 80 L20 80 Z" fill="#c9a84c" fillOpacity="0.1" data-id="element-124" />
            </svg>
          </motion.div>

          {/* The 3 Pillars */}
          <div className="grid md:grid-cols-3 gap-8 relative z-10 w-full" data-id="element-125">
            <motion.div whileHover={{
            y: -5
          }} className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#0f1923] text-center md:col-start-2" data-id="element-126">
              <h3 className="text-2xl font-serif font-bold text-[#0f1923] mb-3" data-id="element-127">
                LÍMITES
              </h3>
              <p className="text-gray-600" data-id="element-128">
                Reglas cortas, visibles y medibles. Sin "a veces sí".
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#c9a84c] text-center md:col-start-1 md:row-start-2" data-id="element-129">
              <h3 className="text-2xl font-serif font-bold text-[#0f1923] mb-3" data-id="element-130">
                REEMPLAZO
              </h3>
              <p className="text-gray-600" data-id="element-131">
                Alternativas listas antes del apagado para evitar el vacío.
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#0f1923] text-center md:col-start-3 md:row-start-2" data-id="element-132">
              <h3 className="text-2xl font-serif font-bold text-[#0f1923] mb-3" data-id="element-133">
                COHERENCIA
              </h3>
              <p className="text-gray-600" data-id="element-134">
                Protocolos que sostienen el límite sin gritar.
              </p>
            </motion.div>
          </div>
        </div>
      </div>

      <div className="mt-10 text-center" data-id="element-135">
        <p className="text-xl font-medium text-[#1a2332] bg-[#c9a84c]/10 inline-block px-6 py-3 rounded-full" data-id="element-136">
          ⚠️ Si te falta una pata del triángulo, vuelve el conflicto.
        </p>
      </div>
    </Section>;
}